module.exports = __webpack_public_path__ + "static/media/glass1.550e027e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/glass1.png
// module id = 726
// module chunks = 0